import { Button, CardActions, CardContent, CardMedia, Divider, Typography } from '@dls/react-core';
import StudyImg from '../../assets/study-image.svg';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../routes/main-routes';
import { StudyMenu } from './study-menu-items';
import { Study } from '../../api/studykit';
import { StyledCard } from '../styled/styles';
import styled from 'styled-components';

const StyledStudyCard = styled(StyledCard)`
  :hover {
    cursor: pointer;
  }
`;

const StyledDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-evenly;
`;

const StyledCardMedia = styled(CardMedia)`
  width: 235px;
  height: 230px;
`;

const StyledCardContent = styled(CardContent)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 1em !important;
  justify-content: space-between;
`;

interface StudyCardProps {
  study: Study;
}

const StudyCard: React.FC<StudyCardProps> = ({ study }) => {
  const navigate = useNavigate();

  const { name, organization, start, end, numberOfSubjects, id } = study;

  const handleClick = () => navigate(`/${RoutePaths.Studies}/${id}`);

  return (
    <StyledStudyCard onClick={handleClick}>
      <StyledCardMedia dls_class={'full-card'} image={StudyImg} title="Study" />

      <StyledCardContent>
        <StyledDetails>
          <Typography variant="h3" data-testid="study-name">
            {name}
          </Typography>

          <Typography extra_variant="body3" data-testid="study-organization">
            {organization}
          </Typography>
          <Typography extra_variant="body2" data-testid="study-period">
            {new Date(start).toLocaleDateString()} to {new Date(end).toLocaleDateString()}
          </Typography>
          <Typography extra_variant="body2" data-testid="study-participants">
            {numberOfSubjects} {numberOfSubjects === 1 ? 'subject' : 'subjects'}
          </Typography>
        </StyledDetails>
        <div>
          <Divider className={'DLS-divider'} />
          <CardActions style={{ justifyContent: `space-between` }}>
            <Button data-testid="study-navigate-link" dls_variant="quietEmphasis">
              Open
            </Button>
            <StudyMenu study={study} />
          </CardActions>
        </div>
      </StyledCardContent>
    </StyledStudyCard>
  );
};

export default StudyCard;
